import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    overlay: {
      position: 'fixed',
      zIndex: 9500,
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      backgroundColor: 'rgba(255,255,255,.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    modal: {
      background: '#fff',
      padding: theme.spacing(2),
    },
    buttonWrapper: {
      display: 'flex',
      margin: theme.spacing(2),
      justifyContent: 'center',
    },
    button: {
      marginLeft: theme.spacing(1),
    },
  }),
);

export default useStyles;
